var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 70,
    viewBox: "0 0 64 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 68V60.6667C61.3334 56.7768 59.7882 53.0463 57.0376 50.2958C54.2871 47.5452 50.5566 46 46.6667 46H17.3334C13.4436 46 9.71305 47.5452 6.96251 50.2958C4.21198 53.0463 2.66675 56.7768 2.66675 60.6667V68M46.6667 16.6667C46.6667 24.7668 40.1003 31.3333 32.0001 31.3333C23.8999 31.3333 17.3334 24.7668 17.3334 16.6667C17.3334 8.56649 23.8999 2 32.0001 2C40.1003 2 46.6667 8.56649 46.6667 16.6667Z",
    stroke: "#DCF4F0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default "data:image/svg+xml,%3csvg width='64' height='70' viewBox='0 0 64 70' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M61.3334 68V60.6667C61.3334 56.7768 59.7882 53.0463 57.0376 50.2958C54.2871 47.5452 50.5566 46 46.6667 46H17.3334C13.4436 46 9.71305 47.5452 6.96251 50.2958C4.21198 53.0463 2.66675 56.7768 2.66675 60.6667V68M46.6667 16.6667C46.6667 24.7668 40.1003 31.3333 32.0001 31.3333C23.8999 31.3333 17.3334 24.7668 17.3334 16.6667C17.3334 8.56649 23.8999 2 32.0001 2C40.1003 2 46.6667 8.56649 46.6667 16.6667Z' stroke='%23DCF4F0' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };